import moment from 'moment'

export default {
    "entityName": "siterequest",
    upsert: 'full',
    filterStorage: {},
    // "title": "Site request",
    "pagination": {
        "itemsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            value: 'request_date',
            text: 'Date',
            table: { sortable: true, filter: true },
            render: item => moment(item.request_date).format('YYYY-MM-DD'),
        },
        {
            "value": "protocol_id",
            "text": "Protocol",
            "type": "autocomplete",
            "table": {
                "sortable": true,
                filter: true
            },
            "title": "name",
            validators: ['required']
        },
        {
            "value": "site_id",
            "text": "Site",
            title: "city",
            subtitle: item => `${item.name} - ${item.code}`,
            "type": "autocomplete",
            filter: (item, search) => [{ 'site.name': `%${search}%`}, {'site.city': `%${search}%`}, { 'site.code': `%${search}%`}],
            "table": {
                "sortable": true,
                filter: true
            },
            render: item => `${item.site.city} - ${item.site.name}`,
            validators: ['required']
        },
        {
            value: "is_transfer",
            text: "Transfer",
            type: 'check',
            table: { filter: true, sortable: true },
            render: item => item.is_transfer ? '⇄' : ''
        },
        {
            "value": "status",
            "text": "Status",
            "type": "list",
            "table": {
                "sortable": true,
                "filter": true
            },
            "list": [
                "NEW", "REQUESTED", "CONFIRMED", "SENT", "RECEIVED", "CANCELED", "LOST", "IMPORTED"
            ],
            visible: false
        },
        {
            "value": "n_patients",
            "text": "N. patients",
            "type": "number",
            "validators": [
                "required",
                "number"
            ]
        },
        {
            "value": "request_arrival_date",
            "text": "Request arrival date",
            "type": "datetime",
        },
        {
            "value": "urgent",
            "text": "Urgent",
            "type": "check",
            // "table": {
            //     "sortable": true,
            //     "filter": true
            // }
        },
        {
            full: true,
            "value": "urgency_reason",
            "text": "Urgency reason",
            "type": "textarea",
            readonly: item => !item.urgent
        },
        {
            value: 'response_drugs.name, request_drugs.name',
            text: 'Drugs',
            id: 'id',
            filter: (item, search) => [{ 'response_drugs.name': `%${search}%` }, { 'request_drugs.name': `%${search}%`}],
            subtitle: item => `${item.dose}${item.measure_unit} - ${item.protocol.name}`,
            type: 'autocomplete',
            table: {
                filter: true,
            },
            render: item => {
                switch(item.status) {
                    case 'NEW':
                    case 'REQUESTED':
                    case 'CANCELED': {
                        const drugs = item.request_drugs.map((d, idx) => {
                            let ret = d.name + '('
                            ret += d.packaging !== 'Labels' ? d.dose + d.measure_unit : 'labels ' + JSON.parse(d._JSON_labels || '[]').join(',')
                            ret += ' ' + (item.siterequest_has_drug_complete[idx] ? item.siterequest_has_drug_complete[idx].n_pieces : 0)
                            return ret + ')'
                        })

                        return drugs.join(', ')
                            // item.request_drugs.reduce((drugs, drug, idx) => drugs + `${drug.name}(${drug.packaging !== 'Labels' ? drug.dose + drug.measure_unit : 'labels ' + JSON.parse(drug._JSON_labels || '[]').join(',') }, ${item.siterequest_has_drug_complete[idx] && ((item.status === 'CONFIRMED' || item.status === 'SENT') ? item.siterequest_has_drug_complete[idx].n_confirmed : item.siterequest_has_drug_complete[idx].n_confirmed || item.siterequest_has_drug_complete[idx].n_pieces)}) ` , '')
                    }
                    case 'CONFIRMED':
                    case 'SENT':
                    case 'LOST': {
                        const drugs = item.request_drugs.map((d, idx) => {
                            if (!item.siterequest_has_drug_complete[idx] || !item.siterequest_has_drug_complete[idx].n_confirmed) return
                            let ret = d.name + '('
                            ret += d.packaging !== 'Labels' ? d.dose + d.measure_unit : 'labels ' + JSON.parse(d._JSON_labels || '[]').join(',')
                            ret += ' ' + item.siterequest_has_drug_complete[idx].n_confirmed
                            return ret + ')'
                        })

                        return drugs.join(', ')

                    }
                    case 'RECEIVED':
                    case 'IMPORTED':
                    {
                        const drugs = item.response_drugs.map(d => {
                            let ret = d.name + '('
                            ret += d.packaging !== 'Labels' ? d.dose + d.measure_unit : 'labels ' + JSON.parse(d._JSON_labels || '[]').join(',')
                            ret += ' ' + item.siteresponse_has_drug_complete.reduce((tot, c) => tot + (c.drug_id === d.id && c.n_pieces) || 0,0)
                            return ret + ')'
                        })

                        return drugs.join(', ')                        
                    }
                }
            },
            visible: false
        }

    ],
    "actions": [
        "upsert", "audit"
    ]
}
